import { capitalize } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { useIntl } from '@/i18n/hooks/use-intl'

export const useGender = (): {
  genders: {
    value: string
    label: string
  }[]
  getGenderText: (value: string) => string
} => {
  const { formatMessage } = useIntl()

  const genders = useMemo(() => {
    return [
      {
        value: 'any',
        label: formatMessage({ id: 'search:filter_platform_any' }),
      },
      {
        value: 'Female',
        label: formatMessage({ id: 'kol:edit_field_gender_female' }),
      },
      {
        value: 'Male',
        label: formatMessage({ id: 'kol:edit_field_gender_male' }),
      },
      {
        value: 'Else',
        label: formatMessage({ id: 'kol:edit_field_gender_other' }),
      },
    ]
  }, [formatMessage])

  const getGenderText = useCallback(
    (value: string) => {
      const gender = genders.find(
        (_gender) => _gender.value === capitalize(value),
      )

      return (
        gender?.label ??
        formatMessage({ id: 'autoreport:chart_label_empty_data' })
      )
    },
    [genders, formatMessage],
  )

  return { genders, getGenderText }
}
